import { useState } from "react";
import { Box, IconButton, Drawer, Button, Stack, Typography} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { UpdateIcon,InfoIcon  } from "../../../../../../core/global/Icons"
import GroupsIcon from '@mui/icons-material/Groups';
import { FileInfo } from "./FileInfo";

export const ThreeDots = ({handleOpenMember, handleUpdate, v , allUsers,handleMOpen, isLoading}) =>{
    const [open, setOpen] = useState(false);
    const [fileOpen, setFileOpen] = useState (false)


    return (
        <Box>
            <IconButton onClick={(e) =>{e.stopPropagation();setOpen(true)}}><MoreVertIcon /></IconButton>

                <Drawer anchor="bottom" open={open} onClose={() => setOpen(false)} PaperProps={{sx: {borderTopLeftRadius: 16,borderTopRightRadius: 16 , height:'auto',}}} >
                    <Box bgcolor="#fdfdfdff"  borderRadius="16px 16px 0px 0px" boxShadow="0px 0px 24px rgba(3, 3, 3, 0.08)"  p={2}>
                        <Box display="flex" justifyContent="center" mb={1}>
                            <Box height="2px" width="37px" bgcolor="#333333" />
                        </Box>
                            <Typography  fontSize={14} fontWeight={600} lineHeight="25px" noWrap>
                                {v.name}
                            </Typography>
                                <Stack>
                                    <Button fullWidth sx={{fontSize:'14px', display:'flex', justifyContent:'start',color:'#000000ff'}}onClick={(e)=>{e.stopPropagation();handleMOpen(false);setFileOpen(true);setOpen(false)}}> 
                                        <InfoIcon  stroke='#292d32' width="20" height="20" fill="#737373" />
                                        <Typography sx={{pl:'10px', fontSize:'14px'}}>View Details</Typography>
                                    </Button>

                                    <Button fullWidth sx={{fontSize:'14px', display:'flex', justifyContent:'start'}} className="c-pointer"  onClick={(e) =>{handleOpenMember (e, v); setOpen(false)} } >
                                        <GroupsIcon  width="20" height="20"  style={{ color: "#737373" }}/> 
                                        <Typography sx={{pl:'10px', fontSize:'14px',color:'#080707ff' }}>View Member</Typography>
                                    </Button>

                                    <Button fullWidth sx={{fontSize:'14px',  display:'flex', justifyContent:'start',color:'#000000ff'}}  className="c-pointer" onClick={(e) => {handleUpdate (e, v); setOpen(false)}}>
                                        <UpdateIcon  width="20" height="20" />
                                        <Typography sx={{pl:'10px', fontSize:'14px'}}>Update</Typography>
                                    </Button>
                                </Stack>
                    </Box>
                </Drawer>
            <FileInfo open={fileOpen} onClose={()=>setFileOpen(false)} v={v} allUsers={allUsers}  handleOpenMember={handleOpenMember} isLoading={isLoading}/>
        </Box>
    );
}